import { appSchema, tableSchema } from "@nozbe/watermelondb";

export const OFFLINE_RESOURCES_TABLE = "offline_resources";

export const offlineSchema = appSchema({
  version: 1,
  tables: [
    tableSchema({
      name: OFFLINE_RESOURCES_TABLE,
      columns: [
        { name: "cache_key", type: "string", isIndexed: true },
        { name: "scope", type: "string", isIndexed: true },
        { name: "path", type: "string" },
        { name: "payload", type: "string" },
        { name: "cached_at", type: "number", isIndexed: true },
      ],
    }),
  ],
});
